import { $apiPrivate, $apiPublic } from "Api";

export const USER_PATH = "/users";
export const LOGIN_USER_PATH = "/login";
export const LOGOUT_USER_PATH = "/logout";
export const CREATE_USER_PATH = "/create";
export const UPDATE_USER_PATH = "/update";
export const REFRESH_USER_PATH = "/refresh";
export const GET_ALL_USER_PATH = "/all";
export const GET_ALL_ROLES_USER_PATH = "/roles";
export const GENERATE_TELEGRAM_LINK = "/generatelink";

class UsersApi {
  login = async (data) => {
    const { email, password } = data;
    return await $apiPublic.post(USER_PATH + LOGIN_USER_PATH, {
      email,
      password,
    });
  };
  logout = async (userId) => {
    return await $apiPublic.post(USER_PATH + LOGOUT_USER_PATH, {
      userId,
    });
  };
  registration = async (data) => {
    const { email, password, roles, name } = data;
    //roleId = [id,id,id]
    return await $apiPrivate.post(USER_PATH + CREATE_USER_PATH, {
      email,
      password,
      roleId: roles,
      name,
    });
  };
  getAll = async (page = 1, searchValue) => {
    return await $apiPrivate.get(
      USER_PATH + GET_ALL_USER_PATH + `?page=${page}&search=${searchValue}`,
    );
  };
  getAllRoles = async () => {
    return await $apiPrivate.get(USER_PATH + GET_ALL_ROLES_USER_PATH);
  };
  getSingleUser = async (userId) => {
    return await $apiPrivate.get(USER_PATH + "/" + userId);
  };
  updateUser = async (userData) => {
    return await $apiPrivate.post(USER_PATH + UPDATE_USER_PATH, {
      ...userData,
    });
  };
  refreshUser = async () => {
    return await $apiPublic.get(USER_PATH + REFRESH_USER_PATH);
  };
  generateLink = async (userId) => {
    return await $apiPrivate.post(USER_PATH + GENERATE_TELEGRAM_LINK, {
      userId,
    });
  };
}

export default new UsersApi();
